import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const AcceptsInsurance = ({ color }) => (
  <svg width="13" height="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.302 15a.357.357 0 0 1-.15-.037C5.91 14.87 0 12.465 0 7.113V2.397c0-.113.037-.224.13-.299a.44.44 0 0 1 .299-.13c.336 0 3.15-.056 5.63-1.884a.418.418 0 0 1 .504 0c2.461 1.827 5.276 1.884 5.593 1.884.112 0 .243.037.317.13a.44.44 0 0 1 .13.299v4.735c0 5.35-5.91 7.756-6.152 7.85-.037 0-.093.018-.149.018zM.839 2.807v4.307c0 4.307 4.549 6.582 5.463 6.992.913-.41 5.463-2.685 5.463-6.992V2.807c-.951-.056-3.3-.354-5.463-1.846C4.139 2.452 1.79 2.751.839 2.807zm6.47 8.334H5.294a.422.422 0 0 1-.429-.43V8.718H2.853a.422.422 0 0 1-.43-.429V6.274c0-.242.187-.429.43-.429h2.013V3.832c0-.242.187-.429.43-.429h2.013c.243 0 .43.187.43.43v2.013h2.013c.243 0 .429.186.429.429v2.014a.422.422 0 0 1-.429.429l-2.015-.001v2.014c0 .223-.186.41-.429.41zm-1.585-.84h1.174V8.289c0-.243.187-.429.43-.429H9.34V6.684H7.31a.422.422 0 0 1-.43-.428l.001-1.995H5.706v2.014a.422.422 0 0 1-.43.429H3.283v1.174h2.014c.242 0 .429.186.429.429l-.001 1.995z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

AcceptsInsurance.defaultProps = {
  color: colors.blue,
};

AcceptsInsurance.propTypes = {
  color: PropTypes.string,
};

export default AcceptsInsurance;
